import React from 'react';
import { Link } from 'react-router-dom';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Card } from '../ui/Card';
import { ArrowRight, Clock } from 'lucide-react';
const guides = [{
  id: 'solar-vs-roofing',
  tag: 'Industry Comparison',
  title: "Solar vs. Roofing: A Rep's Comparison",
  description: 'We analyze the commission structures, sales cycles, and physical demands of the two biggest D2D verticals.',
  readTime: '8 min read'
}, {
  id: 'crm-breakdown',
  tag: 'Tool Review',
  title: 'CRM Breakdown: Salesforce vs. HubSpot vs. Industry-Specific',
  description: 'Which CRM actually works for door-to-door teams? We tested the top 5 contenders on mobile and desktop.',
  readTime: '12 min read'
}, {
  id: '1099-vs-w2',
  tag: 'Work Models',
  title: 'Understanding 1099 vs. W2 in Door-to-Door',
  description: 'The tax implications, legal protections, and income potential of different employment classifications.',
  readTime: '6 min read'
}];
export function FeaturedGuidesSection() {
  return <SectionWrapper background="muted" data-id="element-157">
      <div className="flex justify-between items-end mb-8" data-id="element-158">
        <div data-id="element-159">
          <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-160">
            Featured Analysis
          </h2>
          <p className="text-slate-600" data-id="element-161">
            Deep dives into the most critical topics in the industry.
          </p>
        </div>
        <Link to="/guides" className="hidden md:flex items-center text-sm font-medium text-teal-700 hover:text-teal-800" data-id="element-162">
          View all guides <ArrowRight className="ml-1 w-4 h-4" data-id="element-163" />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-164">
        {guides.map((guide, index) => <Link key={index} to={`/guide/${guide.id}`} className="block h-full" data-id="element-165">
            <Card hover className="flex flex-col h-full border-slate-200" data-id="element-166">
              <div className="mb-4" data-id="element-167">
                <span className="inline-block px-2 py-1 bg-slate-100 text-slate-600 text-xs font-semibold rounded uppercase tracking-wide" data-id="element-168">
                  {guide.tag}
                </span>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3 leading-snug" data-id="element-169">
                {guide.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow" data-id="element-170">
                {guide.description}
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-slate-100 mt-auto" data-id="element-171">
                <span className="flex items-center text-xs text-slate-400 font-medium" data-id="element-172">
                  <Clock className="w-3 h-3 mr-1" data-id="element-173" /> {guide.readTime}
                </span>
                <span className="text-sm font-medium text-teal-700 flex items-center group cursor-pointer" data-id="element-174">
                  Read Guide{' '}
                  <ArrowRight className="ml-1 w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-175" />
                </span>
              </div>
            </Card>
          </Link>)}
      </div>

      <div className="mt-8 text-center md:hidden" data-id="element-176">
        <Link to="/guides" className="inline-flex items-center text-sm font-medium text-teal-700 hover:text-teal-800" data-id="element-177">
          View all guides <ArrowRight className="ml-1 w-4 h-4" data-id="element-178" />
        </Link>
      </div>
    </SectionWrapper>;
}